import React, { Component, Fragment } from 'react'
import { Mutation, Query } from 'react-apollo'

import { BRANCH_QUERY, SELF_QUERY } from '../../queries'
import { UPDATE_BRANCH } from '../../mutations'
import { accountManagers } from '../../constants'

import { Container } from '../../styles/defaults'

import Hero from '../../components/Hero/'
import Breadcrumb from '../../components/Breadcrumb/'
import Details from '../../containers/Details/'
import Table from '../../components/Table/'
import MobileToggler from '../../components/MobileToggler/'
import Loader from '../../components/Loader/'
import Error from '../../components/Error/'
import DoubleCTA from '../../components/DoubleCTA/'

import withHeaderFooter from '../../wrapper/withHeaderFooter'

import hero from '../../assets/hero/mijnbedrijf/hero.jpg'
import employee from '../../assets/cta/employee.png'
import cta from '../../assets/cta/double-cta.jpg'

class CompanyDetails extends Component {
  render() {
    const { phone, altPhone, email, website, accountManager } = this.props.branch

    const formFields = [
      {
        name: 'phone',
        label: 'Telefoonnummer*',
        value: phone !== null ? phone : '',
        type: 'tel',
        required: 'required'
      },
      {
        name: 'altPhone',
        label: 'Alternatief telefoonnummer',
        value: altPhone !== null ? altPhone : '',
        type: 'tel'
      },
      {
        name: 'email',
        label: 'E-mail*',
        value: email !== null ? email : '',
        type: 'email',
        required: 'required'
      },
      {
        name: 'website',
        label: 'Website',
        value: website !== null ? website : '',
        type: 'url'
      }
    ]

    const contactHeaders = ['Voornaam', 'Achternaam', 'E-mailadres', 'Telefoonnummer']

    let contactPeople = null
    if (accountManager) {
      let contactPerson = accountManagers.find(manager => manager.name === accountManager)
      if (contactPerson) {
        contactPeople = [
          {
            id: 1,
            one: contactPerson.firstName,
            two: contactPerson.lastName,
            three: contactPerson.email,
            four: contactPerson.phone
          }
        ]
      }
    }

    return (
      <Fragment>
        <Hero small={hero} medium={hero} large={hero} retina={hero} title="Bedrijfsgegevens" />

        <Breadcrumb title="Bedrijfsgegevens" />
        <Query query={SELF_QUERY}>
          {({ loading, error, data }) => {
            if (loading) return <Loader from="25%" to="100%" />
            if (error) return <Error error="uw gebruikersgegevens" />
            const { self } = data
            let viewBranch = (self.permissions.includes('VIEW_BRANCH') || self.role === 'MANAGER')
            let editBranch = (self.permissions.includes('EDIT_BRANCH') || self.role === 'MANAGER')  && !this.props.branch.suspended
            if (viewBranch) {
              return (
                <Fragment>
                  <Mutation
                    mutation={UPDATE_BRANCH}
                    variables={{ id: this.props.branchId }}
                    update={(store, { data: { updateBranch } }) => {
                      let data = store.readQuery({
                        query: BRANCH_QUERY,
                        variables: { id: this.props.branchId }
                      })

                      Object.keys(updateBranch).map((key, index) => {
                        if (data.branch[key] !== updateBranch[key] && key !== 'id') {
                          data.branch[key] = updateBranch[key]
                        }
                        return null
                      })

                      store.writeQuery({
                        query: BRANCH_QUERY,
                        data
                      })
                    }}
                  >
                    {(updateBranch, { data, loading, error }) => (
                      <Details
                        updateBranch={updateBranch}
                        data={data}
                        loading={loading}
                        error={error}
                        formFields={editBranch ? formFields : null}
                        branch={this.props.branch}
                        id={this.props.branchId}
                      />
                    )}
                  </Mutation>

                  {contactPeople ? (
                    <MobileToggler title="Uw contactpersoon">
                      <Table headers={contactHeaders} items={contactPeople} editable={false} />
                    </MobileToggler>
                  ) : null}

                  {/* quick whitespace, remove later */}
                  <div style={{ width: '100%', height: '50px' }} />
                  <DoubleCTA
                    content={[
                      {
                        title: 'Vragen?',
                        subtitle: 'We helpen u graag',
                        employee: true,
                        image: employee,
                        link: {
                          content: 'Contact',
                          url: '/contact',
                          target: ''
                        }
                      },
                      {
                        title: 'Benieuwd welke smaak bij u past?',
                        image: cta,
                        link: {
                          content: 'Afspraak maken',
                          url: 'https://kaarskoffie.nl/afspraak-maken',
                          target: '_blank'
                        }
                      }
                    ]}
                  />
                </Fragment>
              )
            } else {
              return (
                <Container mt mb>
                  Onvoldoende rechten om de bedrijfsgegevens te bekijken
                </Container>
              )
            }
          }}
        </Query>
      </Fragment>
    )
  }
}

export default withHeaderFooter(CompanyDetails)



// WEBPACK FOOTER //
// ./src/views/CompanyDetails/index.js